import { getToken } from "@farzoom/common-ui-components";
import { BASE_URL } from "@services/api";
import axios from "axios";

export const useConfig = (config) => {
  if (config.headers) {
    config.headers.Authorization = `Bearer ${getToken()}`;
  }

  return config;
};

export const axiosInstance = axios.create({
  baseURL: `${BASE_URL}/front-agent`,
});

export const axiosFrontAgent = axios.create({
  baseURL: `${BASE_URL}/front-agent`,
});

export const axiosExternalTask = axios.create({
  baseURL: "/api/ext-task/public",
});

axiosInstance.interceptors.request.use(useConfig);
axiosFrontAgent.interceptors.request.use(useConfig);
